import fetch from "@lib/fetch";
import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { RequestUserDirectoryPreviewProps, UserDirectoryPreviewResponse } from "./types";
import { isUserDirectoryPreviewResponse } from "./validators";

/**
 * Initiate a request for user directory preview via pusher
 * This is used in the "Preview Users" features in the Segmenter
 */
export const requestUserDirectoryPreview = reactQueryPostWebsocketAdapter(
  cacheKey,
  async (
    signal,
    { app_group_id: appGroupId, jobToken, ...params }: RequestUserDirectoryPreviewProps
  ): Promise<UserDirectoryPreviewResponse> => {
    return fetch(
      `/engagement/user_directory_preview/${appGroupId}`,
      "POST",
      { job_token: jobToken, ...params },
      { signal }
    );
  },
  isUserDirectoryPreviewResponse
);
